





















































import Vue, { PropType } from 'vue';
import { uploadDoc, Doc } from '@/modules/doc';

interface DataType {
  inputText: string;
  withVideoUrl: boolean;
  docs: File[];
}

interface SendInputType {
  text: string;
  withVideoUrl: boolean;
  docs: Doc[];
}

export default Vue.extend({
  name: 'GChatInputarea',
  props: {
    videoUrl: {
      type: String as PropType<string>,
    },
  },
  data(): DataType {
    return {
      inputText: '',
      withVideoUrl: false,
      docs: [],
    };
  },
  computed: {
    rows() {
      if (this.inputText && this.inputText.length > 0) {
        return 5;
      } else {
        return 1;
      }
    },
  },
  methods: {
    focusChatarea() {
      const chatarea: any = this.$refs.chatarea;
      chatarea.focus();
    },
    // textareaHeightChange() {
    //   const textarea = this.$refs.chatarea;
    //   const resetHeight = new Promise(((resolve) => {
    //     resolve(textarea.style.height = 'auto');
    //   }));
    //   resetHeight.then(() => {
    //     const textareaHeight = textarea.scrollHeight > 154 ? 154 : textarea.scrollHeight;
    //     textarea.style.height = `${textareaHeight}px`;
    //   });
    // },
    onClickVideoUrl() {
      this.withVideoUrl = true;
      this.$emit('video-click');
      this.focusChatarea();
    },
    onDropToTextarea(e: any) {
      e.preventDefault();
      const files = e.dataTransfer.files;
      const fileArray = Object.values(files);
      this.onFileUpload(fileArray);
    },
    onFileUpload(val: any[]) {
      console.log(val);
      this.docs = [...this.docs, ...val];
      this.focusChatarea();
    },
    onDeleteFileAttachment(targetIndex: number) {
      this.docs = this.docs.filter((_doc, i) => i !== targetIndex);
    },
    onDeleteVideoUrl() {
      this.withVideoUrl = false;
    },
    async onSend() {
      const inputValue: SendInputType = {
        text: this.inputText,
        withVideoUrl: this.withVideoUrl,
        docs: [],
      };
      try {
        const owner = this.$auth.cid;
        if (!owner) return;
        const resDocs = [];
        for await (const doc of this.docs) {
          const resDoc = await uploadDoc(
            owner,
            doc,
            doc.name,
            doc.size,
            () => null,
          );
          resDocs.push(resDoc);
        }
        inputValue.docs = resDocs;
        this.$emit('send', inputValue);
        this.inputText = '';
        this.withVideoUrl = false;
        this.docs = [];
      } catch (err: any) {
        console.log(err);
      }
    },
  },
});
